<script setup>
import {
  ref,
  watch,
  onMounted,
} from 'vue';
import IDateRangePicker from '@components/IDateRangePicker/IDateRangePicker.vue';
import useSiteStore from '@vueApp/store/modules/site';
import IFilterPicker from '@components/IFilterPicker/IFilterPicker.vue';

const siteStore = useSiteStore();

const nomsOptions = ref([
  { label: 'КХЛ', value: 71 },
  { label: 'ВХЛ', value: 73 },
  { label: 'МХЛ', value: 75 },
]);

// Один пункт фильтра может соответствовать нескольким id в noms
// (номенклатуры разных сезонов на одну и ту же лигу). Ключ — value пункта.
const NOM_ID_ALIASES = {
  71: [71],
  73: [73, 159],
  75: [75, 158],
};

const filterModel = ref({
  units: [],
  noms: nomsOptions.value[0]?.value,
  dateRange: [],
  selectTypes: [],
});

function getDateRangeParam() {
  if (!filterModel.value.dateRange[0]) return [];
  return `${filterModel.value.dateRange[0]} — ${filterModel.value.dateRange[1]}`;
}

function getNomIdsFilter() {
  return NOM_ID_ALIASES[filterModel.value.noms] ?? [filterModel.value.noms];
}

function applyFilter() {
  siteStore.setSelectTypes(filterModel.value.selectTypes);

  const searchParams = {
    dateRange: getDateRangeParam(),
    objectTags: filterModel.value.units,
    nomIds: getNomIdsFilter(),
  };
  siteStore.searchEvents({ searchParams });
  siteStore.searchSubscriptions({ searchParams });
}

watch(filterModel.value, () => applyFilter());

onMounted(() => {
  applyFilter();
});
</script>

<template>
  <meta
    name="viewport"
    content="width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no"
  >
  <div class="events__filter">
    <div class="container">
      <div
        class="filter-wrapper flex-column flex-lg-row align-items-start align-items-lg-center flex-wrap"
      >
        <i-date-range-picker
          v-model="filterModel.dateRange"
          class="filter-date w-100 w-lg-25 mt-lg-0"
        />
        <div class="filter-container">
          <i-filter-picker
            v-model="filterModel.noms"
            :options="nomsOptions"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@vueform/multiselect/themes/default.css";

.events-filter {
  margin-top: -48px;

  @media (max-width: $screen-xs) {
    margin-top: 0;
  }
}

.filter-wrapper {
  display: flex;

  @media (max-width: $screen-xs) {
    margin-left: -15px;
    margin-right: -15px;
  }
}

.i-filter {
  &__icon {
    transition: transform 0.3s;
    &.active {
      transform: rotate(-180deg);
    }
  }
}

.filter-date {
  margin-right: 56px;
}
</style>
